module.exports = __webpack_public_path__ + "img/SEABANK.37ded8ad.svg";